import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver, Pipe, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { UpdateAccountCompanyDialog } from './actualizar-ctas/updateacc.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SettingsService } from '../../../settings/settings.service'; 
import { MaterialModule } from '../../../material/material.module';
import { CommonModule } from '@angular/common';
import { CrearCuentaBancariaComponent } from './crear-cuenta-bancaria/crear-cuenta-bancaria.component';
declare var $ :any;


@Component({
  selector: 'ctas',
  standalone: true,
  imports: [MaterialModule, ReactiveFormsModule, FormsModule, CommonModule],
  templateUrl: './ctas.html',
  styleUrls: ['./ctas.less']
})


export class CuentasBancarias implements OnInit, OnChanges {

  role: any;

  @Input() id_company:any;
  //0 no actualizar 1 actualizar
  @Input() actualizar = 0;
  @Input() se_abrio_como_dialogo:boolean=false;
  has_accounts: boolean = false;
  sw_edit = true;
  all_accounts: any[] = [];

  valForm:FormGroup;

  @ViewChild('parent_accounts', { read: ViewContainerRef }) container_accounts!: ViewContainerRef;
  
  constructor(private _cfr: ComponentFactoryResolver, public dialog: MatDialog, public snackBar: MatSnackBar, fb: FormBuilder, public settings: SettingsService,private _formBuilder: FormBuilder ) {


      this.valForm = this._formBuilder.group({
        filter_cta: [''],
      });
    
  }

  @Input() company_id: number | null = null;

  ngOnChanges(changes: SimpleChanges){
    console.log("actualizar cambio: ", this.actualizar)
    if(this.actualizar == 1){
      this.reloadAccounts();
      this.actualizar = 0;
    }
    if (changes['company_id'] && !changes['company_id'].firstChange) {
      this.reloadAccounts();
    }
  }


  ngOnInit() {
    this.role = localStorage.getItem("role")
    this.load_accounts()
  }

  filtro="";
  async load_accounts() {
    try {
      let url = 'cliente-inversionista/bank-accounts/?filtro=' + this.filtro;
      if (this.company_id) url += '&company_id=' + this.company_id;
      const bd: any = await this.settings.get_query(1, url);
      const body_data: any = bd._body;
  
      console.log("Respuesta completa de la API:", body_data);
  
      if (bd.status === 200) {
        this.has_accounts = body_data.info.accounts.length === 0;
  
        this.container_accounts.clear();
        this.all_accounts = [];
  
        body_data.info.accounts.forEach((account: { id: any; bank: { name: any; id: any; }; name: any; email: any; is_primary: any; tipo_cuenta: { name: string; id: any; }; rut: any; number: any; is_tercero: boolean; }) => {
          const comp = this._cfr.resolveComponentFactory(UpdateAccountCompanyDialog);
          const dComponent = this.container_accounts.createComponent(comp);
  
          dComponent.instance.sw_edit = this.sw_edit;
          dComponent.instance.id = account.id;
          dComponent.instance.banco = account.bank.name;
          dComponent.instance.proveedor = account.name;
          dComponent.instance.email = account.email;
          dComponent.instance.load_data = false;
  
          // Configuración según si es cuenta principal
          if (account.is_primary) {
            dComponent.instance.star = "star";
            dComponent.instance.star_class = "add_primary";
            dComponent.instance.is_primary_text = account.tipo_cuenta.name + " - Cuenta Principal";
            dComponent.instance.disabled_delete = true;
          } else {
            dComponent.instance.star = "star_border";
            dComponent.instance.star_class = "add_primary_off";
            dComponent.instance.is_primary_text = account.tipo_cuenta.name;
            dComponent.instance.disabled_delete = false;
          }
  
          this.role = localStorage.getItem("role");
          dComponent.instance.disabledButton = this.role === "teso";
  
          dComponent.instance.info = this;
          dComponent.instance.id_company = this.id_company;
          dComponent.instance.run = account.rut;
          dComponent.instance.number = account.number;
          dComponent.instance.is_tercero = account.is_tercero;
  
          dComponent.instance.full_name = account.name;
          dComponent.instance.bank_selected = account.bank.id;
          dComponent.instance.account_selected = account.tipo_cuenta.id;
  
          this.all_accounts.push(dComponent);
        });
  
        setTimeout(() => {
          $("#parent_accounts").addClass("accordion_show");
        }, 200);
      }
    } catch (error) {
      console.error("Error al cargar las cuentas:", error);
    }
  }
  

  buscar_cta(){
    let filtro = this.valForm.controls['filter_cta'].value;
    this.filtro = filtro;
    this.reloadAccounts();
  }

  reset_cta($e:any){
    if($e.target.value == ""){
      this.filtro = "";
      this.reloadAccounts();
    }
  }

  reloadAccounts() {
    $("#parent_accounts").removeClass("accordion_show");

    this.container_accounts.clear();
    this.all_accounts = [];

    this.load_accounts();

  }

  create_account() {
    const dialogRef = this.dialog.open(CrearCuentaBancariaComponent);
    dialogRef.componentInstance.info = this;
    dialogRef.componentInstance.id_company = this.id_company;
    dialogRef.afterClosed().subscribe((result:any) => { });
  }




}


